import { UserSecurityApiClient } from '@fourthwall/services/dist/UserSecurityApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useUserSecurityQuery = createQueryHook(UserSecurityApiClient.getUserSecurity, {
  queryKey: ['userSecurity'],
})
